import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", { class: "modal-card-head" }, null, -1)
const _hoisted_4 = { class: "modal-card-body" }
const _hoisted_5 = { class: "columns" }
const _hoisted_6 = { class: "column is-narrow" }
const _hoisted_7 = { class: "column" }
const _hoisted_8 = { class: "is-size-1 mb-2 has-text-weight-bold" }
const _hoisted_9 = { class: "is-size-5" }
const _hoisted_10 = { class: "modal-card-foot" }
const _hoisted_11 = { class: "columns" }
const _hoisted_12 = { class: "buttons column has-text-right is-fullwidth" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "clear", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "material-icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(`has-text-${_ctx.modalClass} material-icons modal-icon`)
            }, _toDisplayString(_ctx.modalIcon), 3)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.message), 1)
          ])
        ])
      ]),
      _createElementVNode("footer", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "button has-background-grey-lighter pl-6",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('result',false))),
              "data-test": "close-confirm"
            }, _hoisted_14),
            _createElementVNode("button", {
              class: _normalizeClass(`is-${_ctx.modalClass} button pl-6`),
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('result',true)))
            }, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.actionIcon), 1)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}